import { NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, InjectionToken, inject } from "@angular/core";
import { TranslocoModule } from "@ngneat/transloco";
import { environment } from "environments/environment";

export interface UatBannerContext {
    environment: string;
    hostname: string;
}

/** Entorno y host de la página; inyectable para los tests. */
export const UAT_BANNER_CONTEXT = new InjectionToken<UatBannerContext>("UAT_BANNER_CONTEXT", {
    providedIn: "root",
    factory: () => ({ environment: environment.environment ?? "", hostname: window.location.hostname }),
});

/** El slug es la primera etiqueta del host: `<slug>.uat.geoactivate.abacus-consulting.net`. */
export function uatSlug(context: UatBannerContext): string | null {
    if (context.environment !== "uat") {
        return null;
    }

    return context.hostname.split(".")[0] || "uat";
}

/**
 * Banda fija de los entornos uat (plan 03): quien prueba ahí tiene que saber en todo momento que
 * MediaSmart es el real, con las organizaciones de pre, y que lo que cree se borra al cerrar la feature.
 */
@Component({
    selector: "uat-banner",
    standalone: true,
    imports: [NgIf, TranslocoModule],
    templateUrl: "./uat-banner.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UatBannerComponent {
    readonly slug = uatSlug(inject(UAT_BANNER_CONTEXT));
}
